import React from 'react';
import Column from "@Containers/components/Column";
import Time from "@DateTime/components/Time";
import Row from "@Containers/components/Row";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import RouteType from "@Route/types/Route.type";
import RouteConnection from "@Route/components/Connection/RouteConnection";
import RouteBusLayover from "@Route/components/Connection/ExpandedRoute/RouteBusLayover";

interface RouteTravelDetailsWithBusChangesProps {
    /**
     *  RouteWithAddedPropsAndPricesType is added here because of Search Results.
     *
     *  RouteType is added here because of Check Order.
     */
    route: RouteWithAddedPropsAndPricesType | RouteType,
    companyLetterCode: string,
}

function RouteTravelDetailsWithBusChanges({route, companyLetterCode}: RouteTravelDetailsWithBusChangesProps) {
    const {
        travelInfo: {
            departureStation: {
                name: departureStationName,
                departureTime,
                departureDate,
            },
            destinationStation: {
                name: destinationStationName,
                arrivalTime,
                arrivalDate,
            },
            busChange,
        },
    } = route || {}

    return (
        <Column className="route-travel-details">
            <Row>
               <span className="route-travel-details--first-column-large">
                     <Time
                         time={departureTime}
                         className="gb--emphasize-default"
                     />
               </span>
                <RouteConnection
                    route={route}
                    showVehicleIcon={false}
                    vertical
                    customClass="gb--connect-divider-large"
                />
                <span className="gb--emphasize-default gb--truncate travel-stations__station-name">
                        {departureStationName}
                </span>
            </Row>
            {busChange.map((stop, index) => (
                <RouteBusLayover
                    stop={stop}
                    departureDate={index === 0 ? departureDate : busChange[index - 1].departureDate}
                    departureTime={index === 0 ? departureTime : busChange[index - 1].departureTime}
                    arrivalDate={index < busChange.length - 1 ? busChange[index + 1].arrivalDate : arrivalDate}
                    arrivalTime={index < busChange.length - 1 ? busChange[index + 1].arrivalTime : arrivalTime}
                    numberOfChanges={busChange.length}
                    companyLetterCode={companyLetterCode}
                    index={index}
                />
            ))}
            <Row className="travel-stations__destination-station">
                <span className="route-travel-details--first-column-large">
                     <Time
                         time={arrivalTime}
                         className="gb--emphasize-default"
                     />
                </span>
                <span className="gb--emphasize-default gb--truncate travel-stations__station-name">
                     {destinationStationName}
                </span>
            </Row>

        </Column>
    );
}

export default RouteTravelDetailsWithBusChanges;